import type { HelpText } from '../../components/HelpTip';
import { HELP as WALLET } from '../wallet/help';

/** Explanations behind the "?" icons on the dashboard's Portfolio card, written for clients. */
export const HELP = {
  equity: { ...WALLET.equity, title: 'Total equity' },
  balance: WALLET.balance,
  credit: WALLET.credit,
  usedMargin: {
    title: 'Used margin', learn: '/academy/leverage-margin/margin-used',
    text: 'Money set aside as a deposit to keep your open trades running. You cannot use it for new trades until those trades are closed; then it is released again.',
    example: 'Example: a $1,000 trade at 10× leverage uses $100 of margin.',
  },
  freeMargin: {
    title: 'Free margin', learn: '/academy/leverage-margin/cross-margin',
    text: 'How much you have left to open new trades: your total equity minus used margin and money reserved for pending orders. It moves with the profit or loss on your open trades.',
    example: 'Example: equity $1,020 and used margin $100 → free margin $920.',
  },
  unrealized: WALLET.unrealized,
  realized: {
    title: 'Realized PnL',
    text: 'Profit or loss from trades you have closed in the chosen period: Today (since 00:00 UTC), the last 7 days or the last 30 days. It is already added to your balance. Trading fees are not included.',
  },
} satisfies Record<string, HelpText>;
